define.alias("shared/modifiers/perfect-scroll", "media/modifiers/perfect-scroll");